import { useState } from 'react';

/**
 * Universal form state and change handler hook
 * @param {object} initialState
 * @returns [form, handleChange, setForm]
 */
export function useForm(initialState) {
  const [form, setForm] = useState(initialState);
  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  return [form, handleChange, setForm];
}
